(() => {
  if (customElements.get('softhour-mobile-menu')) return;

  class SofthourMobileMenu extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-sg-menu-open]');
      this.dialog = this.querySelector('dialog[data-sg-menu]');
      if (!this.trigger || !this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.events?.abort();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.mobile = matchMedia('(max-width:899px)');
      this.trigger.hidden = false;
      this.classList.add('is-ready');
      this.trigger.addEventListener('click', () => this.open(), options);
      this.dialog.addEventListener('click', event => {
        if (!(event.target instanceof Element)) return;
        if (event.target.closest('[data-sg-menu-close], a[href]')) {
          this.close();
          return;
        }
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        this.trigger.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('sf-menu-is-open');
        if (this.isConnected && this.mobile.matches) this.trigger.focus({ preventScroll: true });
      }, options);
      this.onResize = () => { if (!this.mobile.matches) this.close(); };
      this.mobile.addEventListener('change', this.onResize);
    }
    open() {
      if (!this.mobile.matches || this.dialog.open) return;
      this.dialog.showModal();
      this.trigger.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('sf-menu-is-open');
    }
    close() { if (this.dialog?.open) this.dialog.close(); }
    disconnectedCallback() {
      this.close();
      this.events?.abort();
      this.mobile?.removeEventListener('change', this.onResize);
      document.documentElement.classList.remove('sf-menu-is-open');
    }
  }
  customElements.define('softhour-mobile-menu', SofthourMobileMenu);
})();
